import type { Customer, Address, AddressCriteria } from '~/types/commercetools';
import { userAddressGetters } from '~/utils/ct';

function getAddresses(billing: Maybe<Partial<Customer>>, criteria?: AddressCriteria): Address[] {
  return userAddressGetters.getAddresses(
    billing?.billingAddresses,
    criteria,
  );
}

function getDefault(billing: Maybe<Partial<Customer>>): Address | undefined {
  return userAddressGetters.getDefault(billing?.billingAddresses, billing?.defaultBillingAddressId);
}

function getTotal(billing: Maybe<Partial<Customer>>): number {
  return userAddressGetters.getTotal(billing?.billingAddresses);
}

export const userBillingGetters = {
  ...userAddressGetters,
  getAddresses,
  getDefault,
  getTotal,
};
